export default "__VITE_ASSET__a038d9f4__"